import {Component, OnInit} from '@angular/core';
import {MstVisitService} from '../configuration/mst-visit/mst-visit.service';
import {Router} from '@angular/router';
import {TemrVisitHistoryService} from '../configuration/temr-visit-history/temr-visit-history.service';
import {TemrVisitChiefComplaintService} from '../configuration/temr-visit-chief-complaint/temr-visit-chief-complaint.service';
import {TemrVisitSymptomService} from '../configuration/temr-visit-symptom/temr-visit-symptom.service';
import {TemrVisitNonDrugAllergyService} from '../configuration/temr-visit-non-drug-allergy/temr-visit-non-drug-allergy.service';
import {TemrVisitAllergyService} from '../configuration/temr-visit-allergy/temr-visit-allergy.service';
import {TemrDoctorsAdviceService} from '../configuration/temr-doctors-advice/temr-doctors-advice.service';
import {CpoeInvestigationService} from '../patient-chart/patient-chart-parent/patient-emr/emr-cpoe/cpoe-investigation/cpoe-investigation.service';
import {TemrVisitPrescriptionService} from '../configuration/temr-visit-prescription/temr-visit-prescription.service';
import {TemrVisitDiagnosisService} from '../configuration/temr-visit-diagnosis/temr-visit-diagnosis.service';
import {TemrVitalService} from '../configuration/temr-vital/temr-vital.service';
import {TemrTimelineService} from '../configuration/temr-timeline/temr-timeline.service';
import {MstUnitService} from '../configuration/mst-unit/mst-unit.service';
import * as base_path from '../shared/my-constants';
import {COVID, CONSTSHIVAMHOSPITAL , CONSTVCNRHOSPITAL ,CONSTMEDIFYHUB} from '../shared/my-constants';
import {CpoeDoctorAdviceService} from '../patient-chart/patient-chart-parent/patient-emr/emr-cpoe/cpoe-doctoradvice/cpoe-doctoradvice.service';
import {TemrVisitDoctorsNoteService} from '../configuration/temr-visit-doctors-note/temr-visit-doctors-note.service';
import {TemrAssociateChiefComplaintService} from '../configuration/temr-associate-chief-complaint/temr-associate-chief-complaint.service';

@Component({
    selector: 'app-case-report',
    templateUrl: './case-report.component.html',
    styleUrls: []
})
export class CaseReportComponent implements OnInit {

    constshivamhospital: boolean = CONSTSHIVAMHOSPITAL;
    CONSTVCNRHOSPITAL : boolean = CONSTVCNRHOSPITAL;
    CONSTMEDIFYHUB :  boolean = CONSTMEDIFYHUB;
    constructor(private router: Router,
                private mstVisitService: MstVisitService,
                private temrVisitHistoryService: TemrVisitHistoryService,
                private temrVisitChiefComplaintService: TemrVisitChiefComplaintService,
                private temrAssoVisitChiefComplaintService: TemrAssociateChiefComplaintService,
                private temrVisitSymptomService: TemrVisitSymptomService,
                private temrVisitNonDrugAllergyService: TemrVisitNonDrugAllergyService,
                private temrVisitAllergyService: TemrVisitAllergyService,
                private temrDoctorsAdviceService: TemrDoctorsAdviceService,
                private cpoeInvestigationService: CpoeInvestigationService,
                private temrVisitPrescriptionService: TemrVisitPrescriptionService,
                private temrVisitDiagnosisService: TemrVisitDiagnosisService,
                private temrVitalService: TemrVitalService,
                private temrTimelineService: TemrTimelineService,
                private mstUnitService: MstUnitService,
                private cpoeDoctorAdviceService: CpoeDoctorAdviceService,
                private temrVisitDoctorsNoteService: TemrVisitDoctorsNoteService
    ) {
    }
    covid: Boolean = COVID;
    private linkSource: any;
    private timeline_id: any;
    private currentPatient: any = {};
    private currentPatientId: any;
    private currentVisit: any = {};
    timeline: any = {};
    mstUnit: any = {};
    unitid: any;
    symptomName: any;
    temrVisitHistory: any = {};
    chipComplaintes: Array<any> = [];
    assoChipComplaintes: Array<any> = [];
    chipSymptoms: any[] = [];
    chipAllergies: any[] = [];
    allergyList: Array<any> = [];
    usersign_url = base_path.usersign;
    doctorAdviceContent: any = '';
    investigationService: Array<any> = [];
    diagonasisArray: Array<any> = [];
    currentPrescription: any = {};
    filteredPrescription: Array<any> = [];
    temrVitalList: Array<any> = [];
    temrTimelistList: Array<any> = [];
    currentUserdetails: any;
    clinicalProcedureList: Array<any> = [];
    savedOtRequest: Array<any> = [];
    isTata: Boolean = false;
    sympname: Boolean = false;
    selectedClinicalFinding: Array<any> = [];
    drNotsList: Array<any> = [];

    ngOnInit() {
        this.isTata = base_path.Tata;
        this.unitid = JSON.parse(sessionStorage.getItem('unitId'));
        this.currentUserdetails = JSON.parse(sessionStorage.getItem('userdetail'));
        // console.log('Login User :', this.currentUserdetails);
        this.getUnitDetailsById(this.unitid);
        const a = this.router.url.split('/'); //  Delimiter is a string
        this.linkSource = a[2];
        this.timeline_id = a[3];
        this.getTimelineDetails();
    }

    getVisit() {
        if (this.linkSource === 'ipd') {
            this.mstVisitService.getVisitByPatientIdOfIpdPatient(this.timeline.timelinePatientId.patientId, 1)
                .then(resp => {
                    this.currentVisit = resp;
                    this.currentPatient = resp.visitPatientId;
                    this.currentPatientId = resp.visitPatientId.patientId;
                    //this.getUnitDetailsById(this.unitid);
                    this.getVisitAllergies(this.currentPatientId);
                });
        }
        else {
            this.mstVisitService.getRecordService(this.timeline.timelineVisitId.visitId).then(resp => {
                // console.log(resp);
                this.currentPatient = resp.visitPatientId;
                this.currentPatientId = resp.visitPatientId.patientId;
                // console.log(this.currentPatientId);
                this.currentVisit = resp;
                // console.log(resp);
                //   this.getUnitDetailsById(this.unitid);
                this.getVisitAllergies(this.currentPatientId);
            });
        }
    }

    navigateBack() {
        this.router.navigate(['patientchart/patient-chart-parent/' + this.linkSource + '/' + this.currentVisit.visitId + '/patient-timeline']);
    }

    getHistory() {
        // this.temrVisitHistoryService.getRecordServiceByTimelineId(this.timeline.timelinePatientId.patientId).then(resp => {
        //     console.log("getHistory");
        //      console.log(resp);
        //   if (resp['_body'] !== '') {
        //     this.temrVisitHistory = resp;
        //     //  this.historyTemplate = resp.json().vhContent;
        //     //    // console.log(resp.json());
        //   }
        // });
        // this.temrVisitHistoryService.getRecordByPatientIdHistory(this.timeline.timelinePatientId.patientId).then(resp => {
        this.temrVisitHistoryService.getRecordByPatientIdHistory(this.timeline_id).then(resp => {
            if (resp.vhContent != '') {
                // console.log('history');
                 console.log(resp);
                this.temrVisitHistory = resp;
                console.log('history',this.temrVisitHistory.vhContent);
            }
        });
    }

    // getEMRFinalizeStaff() {
    //   this.temrTimelineService.getRecordByVisitIdService(this.timeline.timelineVisitId.visitId).then(resp => {
    //     this.temrTimelistList = resp;
    //     // console.log('TimeLine List: ');
    //     // console.log(this.temrTimelistList);
    //   });
    // }
    getChiefCompaints() {
        this.temrVisitChiefComplaintService.getRecordServiceByTimelineId(this.timeline_id).then(resp => {
            this.chipComplaintes = resp;
            // for (const obj of resp) {
            //   let tempobj: any = {};
            //   tempobj = obj.vccCcId;
            //   tempobj.vccId = obj.vccId;
            //   //   // console.log(tempobj);
            //   this.chipComplaintes.push(tempobj);
            // }
            // console.log('chipComplaintes');
            // console.log(resp);
        });
    }
    getAssoChiefCompaints() {
        this.temrAssoVisitChiefComplaintService.getRecordServiceByTimelineId(this.timeline_id).then(resp => {
            this.assoChipComplaintes= resp;
            // for (const obj of resp) {
            //   let tempobj: any = {};
            //   tempobj = obj.vccCcId;
            //   tempobj.vccId = obj.vccId;
            //   //   // console.log(tempobj);
            //   this.chipComplaintes.push(tempobj);
            // }
            // console.log('chipComplaintes');
            // console.log(resp);
        });
    }
    getSymptoms() {
        this.temrVisitSymptomService.getByTimelineRecordService(this.timeline_id).then(resp => {
            this.chipSymptoms = resp;
            console.log('chipSymptoms::', this.chipSymptoms);
            if (resp.vsSymptomId == null || resp.vsSymptomId == undefined || resp.vsSymptomId == '') {
                this.sympname = true;
                this.symptomName = resp.vsSignSymptoms;
                console.log('symtons name::', this.symptomName);
            }
            // console.log(resp);
        });
    }

    getNonDrugAllergies() {
        this.temrVisitNonDrugAllergyService.getByTimelineIdRecordService(this.timeline_id).then(resp => {
            for (const obj of resp) {
                let tempobj: any = {};
                tempobj = obj.vndaNdaId;
                //  // console.log(tempobj);
                this.chipAllergies.push(obj);
            }
            //  // console.log(this.chipAllergies);
        });
    }

    getVisitAllergies(patientId: any) {
        this.temrVisitAllergyService.getAllRecordByPatientIdService('1', '', patientId, '', '').then(
            resp => {
                this.allergyList = resp.json().content;
                if (resp['_length'] > 0) {
                }
                // console.log('visitAllergy:');
                // console.log(this.allergyList);
                //  // console.log(JSON.stringify(this.allergyList));
            });
    }

    getDoctorAdvice() {
        this.temrDoctorsAdviceService.getClinicalRecordByTimelineId('', '', this.timeline_id, '', '').then(resp => {
            // console.log('doctorAdviceContent');
            // console.log(resp);
            if (resp['_body'] !== '') {
                this.doctorAdviceContent = resp.dcContent;
            }
        });
    }

    getInvestigation() {
        this.cpoeInvestigationService.getRecordByTimelineId('', '', this.timeline_id, '', '').then(resp => {
            if (resp['_body'] !== '') {
                this.investigationService = resp;
                //  // console.log(this.investigationService);
            }
        });
    }

    getPrespription() {
        this.temrVisitPrescriptionService.getPrescriptionByTimelineId(this.timeline_id)
            .then(resp => {

                //  // console.log(resp);
                this.currentPrescription = resp;
                this.filteredPrescription = resp;
                // console.log('prescription');
                // console.log(resp);
                if (this.currentPrescription.length != 0) {
                    for (let i = 0; i < (this.currentPrescription).length; i++) {
                         // this.filteredPrescription = item;
                        this.filteredPrescription.push(this.currentPrescription.itemPrescriptionList[i]);
                        //  // console.log(this.filteredPrescription);
                    }
                }
            });
    }

    getDiagonasis() {
        this.temrVisitDiagnosisService.getAllRecordServicebyTimelineId('', '', this.timeline_id, '', '')
            .then(resp => {
                    this.diagonasisArray = resp;
                console.log("ts"+this.diagonasisArray);
            });
    }

    getVitals() {
        this.temrVitalService.getAllRecordServicebyTimelineId(1, 50, this.timeline_id, '', '')
            .then(resp => {
                console.log("vital:- " +resp);
                if (resp !== '') {
                    this.temrVitalList = resp;
                }
                // console.log('Vital Details:');
                // console.log(this.temrVitalList);
            });
    }

    getClinicalProcedure() {
        this.temrDoctorsAdviceService.getClinicalRecordByTimelineId_new('', '', this.timeline_id, '', '').then(respClinicalProcedure => {
            this.clinicalProcedureList = respClinicalProcedure;
            console.table(respClinicalProcedure);
        });
    }

    printCasePaper(): void {
        let printContents, popupWin;
        printContents = document.getElementById('print-section').innerHTML;
        popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
        popupWin.document.open();
        popupWin.document.write(`
      <html>
        <head>
          <title>Print tab</title>
          
          <link rel="stylesheet" href="assets/css/your_style.css">
          
          <!-- Latest compiled and minified CSS -->
          <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/4.1.0/css/bootstrap.min.css">
          
          <!-- jQuery library -->
          <script src="https://ajax.googleapis.com/ajax/libs/jquery/3.3.1/jquery.min.js"></script>
          
          <!-- Popper JS -->
          <script src="https://cdnjs.cloudflare.com/ajax/libs/popper.js/1.14.0/umd/popper.min.js"></script>
          
          <!-- Latest compiled JavaScript -->
          <script src="https://maxcdn.bootstrapcdn.com/bootstrap/4.1.0/js/bootstrap.min.js"></script>
          
          <style>
          .pull-right
          {
             float: right;
          }
          @media print {
            body{              
                -webkit-print-color-adjust: exact; 
            }
           }
          
          .ui-grid-col-12 {
              width: 100%;
          }
          .col-xs-12{
              width: 100%;
          }
          
          .col-xs-6{
              float: left;              
              position: relative;
              min-height: 1px;
              padding-right: 15px;
              padding-left: 15px;
          }
            
          h5 {
            font-size: 17px;
            font-weight: 300;
            line-height: normal;
          } 
          
          .bordered {
              border: 1px solid rgba(0, 0, 0, .2);
          }
          
          .caseReport .ui-panel-titlebar{
              padding: 0px 0px 0px 10px;
            }
            
            .caseReport h5{
              margin: 5px 0;
            }
            
            .caseReport .ui-widget-header{
              background: #337ab7;
              color: #fff;
              border-color: #337ab7;
            }
            
            .caseReportPrimary .ui-widget-content{
              border: 1px solid #337ab7;
              border-left: 5px solid #337ab7;
            }
            
            .caseReportInfo .ui-widget-content{
              border: 1px solid #17a2b8;
              border-left: 5px solid #17a2b8;
            }
            
            .caseReportWarning .ui-widget-content{
              border: 1px solid #ffc107;
              border-left: 5px solid #ffc107;
            }
            
            .caseReportDanger .ui-widget-content{
              border: 1px solid #dc3545;
              border-left: 5px solid #dc3545;
            }
            
            .caseReportSuccess .ui-widget-content{
              border: 1px solid #28a745;
              border-left: 5px solid #28a745;
            }
            </style>
        </head>
        <body onload="window.print();window.close()">${printContents}</body>
      </html>`
        );
        popupWin.document.close();
    }

    getUnitDetailsById(id: any) {
        this.mstUnitService.getRecordService(id)
            .then(resp => {
                this.mstUnit = resp;
                // console.log('unit details');
                // console.log(resp);
            });
    }

    getTimelineDetails() {
        this.temrTimelineService.getRecordService(this.timeline_id)
            .then(resp => {
                this.timeline = resp;
                // console.log('timeline details');
                // console.log(resp);
                if (this.timeline.timelineEMRFinalStaffId.staffSignName === '') {
                    this.timeline.timelineEMRFinalStaffId.staffSignName = null;
                    // console.log(this.timeline.timelineEMRFinalStaffId.staffSignName);
                }
                if (this.linkSource === 'ipd') {
                    this.getVisit();
                }
                else {
                    this.currentPatient = this.timeline.timelineVisitId.visitPatientId;
                    // this.currentPatientId = this.timeline.timelineVisitId.visitPatientId.patientId;
                    this.currentPatientId = this.timeline.timelinePatientId.patientId;
                    // console.log(this.currentPatientId);
                    this.currentVisit = this.timeline.timelineVisitId;
                    //   this.getUnitDetailsById(this.unitid);
                    this.getVisitAllergies(this.currentPatientId);
                }
                this.getHistory();
                this.getChiefCompaints();
                this.getAssoChiefCompaints();
                this.getSymptoms();
                this.getNonDrugAllergies();
                this.getVitals();
                this.getDiagonasis();
                this.getInvestigation();
                this.getPrespription();
                this.getClinicalProcedure();
                this.getOtRequestList();
                this.getClinicalFinding();
                this.getDoctorsNote();
                //  this.getEMRFinalizeStaff();
            });
    }

    getOtRequestList() {
        this.savedOtRequest = [];
        this.cpoeDoctorAdviceService.getRecordOtRequestByTimelineId_new('', '', this.timeline.timelineId, '', '')
            .then(resp => {
                console.log('getOtRequestList');
                console.log(resp);
                this.savedOtRequest = resp;
            });
    }

    getDoctorsNote() {
        this.temrVisitDoctorsNoteService.getAllRecordByPatientIdService_new('1', '', this.currentPatient.patientId, '', '').then(
            resp2 => {
                this.drNotsList = resp2.json();
                console.log('d note ', this.drNotsList);
            }
        );
    }

    getClinicalFinding() {
        this.cpoeDoctorAdviceService.getRecordClinicalFindingByTimelineId_new(this.timeline.timelineId).then(resp => {
            this.selectedClinicalFinding = resp;
            console.log(resp);
        });
    }
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/case-report/case-report.component.ts